export default __webpack_public_path__ + "static/media/kajjaya.7a6701d4.png";